var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdersCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 28C32 28 37.4065 28 43.8807 28C50.3549 28 55.6033 28 55.6033 28C55.6033 34.4742 50.3549 38.7288 43.8807 38.7288C37.4065 38.7288 32 34.4742 32 28Z",
    fill: "#00A3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9077 47.547L65.3471 25.2288L62.8002 24.3794L55.9727 44.8632H31.0701L21.6769 16.6837H14V19.3675H19.7419L28.6654 46.1353L22.6699 59.6239H59.624V56.9402H26.8002L30.9748 47.547H57.9077Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1283 66.3333C35.6105 66.3333 36.8121 65.1318 36.8121 63.6496C36.8121 62.1674 35.6105 60.9658 34.1283 60.9658C32.6461 60.9658 31.4446 62.1674 31.4446 63.6496C31.4446 65.1318 32.6461 66.3333 34.1283 66.3333Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2309 66.3333C51.7131 66.3333 52.9146 65.1318 52.9146 63.6496C52.9146 62.1674 51.7131 60.9658 50.2309 60.9658C48.7487 60.9658 47.5471 62.1674 47.5471 63.6496C47.5471 65.1318 48.7487 66.3333 50.2309 66.3333Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1795 14V22.0513H34.1282V24.7351H42.1795V32.7863H44.8632V24.7351H52.9145V22.0513H44.8632V14H42.1795Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersCart);
export default __webpack_public_path__ + "static/media/orders-cart.29aa267582d0eb83936673bcfbec7287.svg";
export { ForwardRef as ReactComponent };